import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

const TWENTY_MINUTES = 20 * 60 * 1000;

export const useActionIdentifiers = () => {
  const { data, ...queryResponse } = useQuery({
    queryKey: ["action-identifiers"],
    queryFn: api.actionIdentifiers.fetchAll,
    staleTime: TWENTY_MINUTES,
    gcTime: TWENTY_MINUTES,
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return {
    identifiers: data,
    fetchState,
  };
};
